import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

const state = {
  checkoutItems: JSON.parse(localStorage['checkoutItems'] || '[]')
}

@Injectable({
  providedIn: 'root'
})
export class OrderService {

  constructor(private router: Router, private http: HttpClient,) { }

  // Get Checkout Items
  public get checkoutItems(): Observable<any> {
    const itemsStream = new Observable(observer => {
      observer.next(state.checkoutItems);
      observer.complete();
    });
    return <Observable<any>>itemsStream;
  }

  // Create order
  public createOrder(product: any, details: any, orderId: any, amount: any) {
    var item = {
      shippingDetails: details,
      product: product,
      orderId: orderId,
      totalAmount: amount
    };
    state.checkoutItems = item;
    localStorage.setItem("checkoutItems", JSON.stringify(item));
    localStorage.removeItem("cartItems");
    this.router.navigate(['/shop/checkout/success', orderId]);
  }


  public Orders
  public getorders(): Observable<OrderService[]> {
    const cusid = localStorage.getItem('customerid');

    var secid = localStorage.getItem('secid');
    if (cusid == null || '') {
      this.router.navigateByUrl('home/fashion')
    }
    const apiUrl = 'https://uat-ecom.azurewebsites.net/api/Home/getEcomOrders?custid=' + cusid + '&secid=' + secid;
    this.Orders = this.http.get<OrderService[]>(apiUrl);
    return this.Orders;
  }

  public get Orderget(): Observable<OrderService[]> {
    return this.getorders();
  }

  public sid = 0

  public GetOrders(sid) {
    this.sid = sid
  }


  public YourOrders
  public getordersEcom(): Observable<OrderService[]> {
    const cusid = localStorage.getItem('customerid');

    var secid = localStorage.getItem('secid');
    if (cusid == null || '') {
      this.router.navigateByUrl('home/fashion')
    }
    const apiUrl = 'https://uat-ecom.azurewebsites.net/api/Home/getEcomOrderIndex?custid=' + cusid + '&secid=' + secid + '&sid=' + this.sid;
    this.YourOrders = this.http.get<OrderService[]>(apiUrl);
    return this.YourOrders;
  }

  public get OrdergetEcom(): Observable<OrderService[]> {
    return this.getordersEcom();
  }

  public OrderById = 0

  public GetorderById(OrderById) {
    // console.log(this.OrderById)
    this.OrderById = OrderById
    // return this.OrderById
  }
  public orderbyId
  public getordersEcombyId(): Observable<OrderService[]> {
    const apiUrl = 'https://uat-ecom.azurewebsites.net/api/Home/getEcomOrdersEdit?ecomorderid=' + this.OrderById
    this.orderbyId = this.http.get<OrderService[]>(apiUrl);
    return this.orderbyId;
  }

  public get OrdergetbyId(): Observable<OrderService[]> {
    return this.getordersEcombyId();
  }


  public saveorderpayload

  public saveorderpay(body) {
    const apiUrl = 'https://uat-ecom.azurewebsites.net/api/home/saveCartDetails';

    this.saveorderpayload = this.http.post(apiUrl, body);
    return this.saveorderpayload;
  }

}
